import PrinterConnectedIcon from '~Assets/icons/print_connect.svg';
import PrintErrorIcon from '~Assets/icons/print_error.svg';
import SignalDisconnectedIcon from '~Assets/icons/signal_disconnected.svg';
import PrintDisabledIcon from '~Assets/icons/print_disabled.svg';

export const STATUS_COLORS = {
  OK: 'var(--colorUIGreen)',
  ERROR: 'var(--colorUIRed)',
  WARNING: 'var(--colorUIOrange)',
  NOT_CONNECTED: 'var(--colorStatusGray)',
};

export const STATUS_ICONS = {
  OK: PrinterConnectedIcon,
  ERROR: PrintErrorIcon,
  WARNING: SignalDisconnectedIcon,
  NOT_CONNECTED: PrintDisabledIcon,
};

export type StatusType = 'OK' | 'ERROR' | 'WARNING' | 'NOT_CONNECTED';
